const currentURL = window.location.pathname;
const checkActive = link =>
  currentURL.indexOf(link.getAttribute("href")) !== -1;

const addActiveNavClass = () => {
  const navLinks = document.querySelectorAll("#top-navigation .nav__link");
  const activeLink = [...navLinks].find(link => checkActive(link));

  // activeLink is undefined for home page
  if (activeLink) activeLink.classList.add("active");
};

const addMobileTogglerHandlers = () => {
  const toggleMenu = document.querySelector("#toggle-menu");
  const body = document.querySelector("body");
  if (!toggleMenu) return; // for tests

  toggleMenu.addEventListener("click", e => {
    e.preventDefault();

    const subNavItems = document.querySelectorAll(
      "#top-navigation .open:not(#top-navigation):not(#toggle-menu):not(.top-nav)"
    );

    [...subNavItems].forEach(el => el.classList.remove("open"));

    const topNavItems = document.querySelectorAll(
      "#top-navigation, #toggle-menu, .top-nav"
    );

    [...topNavItems].forEach(el => el.classList.toggle("open"));

    if (toggleMenu.classList.contains("open")) {
      body.classList.add("lock-position");
    } else {
      body.classList.remove("lock-position");
    }
  });
};

const toggleSubNav = e => {
  e.preventDefault();
  e.stopPropagation();
  const clickedSubnav = e.currentTarget.getAttribute("data-toggle-subnav");
  const subnavListSelector = `[data-subnav="${clickedSubnav}"]`;

  // close other active ul and nav items
  const open = document.querySelectorAll(
    `.top-nav__link.open:not([data-toggle-subnav="${clickedSubnav}"]), .subnav__list.open:not(${subnavListSelector})`
  );
  [...open].forEach(el => el.classList.remove("open"));

  // simulate hover state on link and open list
  e.currentTarget.classList.toggle("open");
  document.querySelector(subnavListSelector).classList.toggle("open");
};

const addMobileSubMenuHandlers = () => {
  [...document.querySelectorAll("[data-toggle-subnav]")].forEach(el => {
    el.addEventListener("click", toggleSubNav);
  });
};

const addNavScrollHandler = () => {
  const topNav = document.querySelector("#top-navigation");
  window.addEventListener("scroll", function(e) {
    if (!topNav) return;
    if (window.pageYOffset > 0) {
      topNav.classList.add("scrolled");
    } else {
      topNav.classList.remove("scrolled");
    }
  });
};

const addFooterHandlers = () => {
  document
    .querySelectorAll("#footer-navigation nav strong")
    .forEach(function(item) {
      item.addEventListener("click", function(e) {
        e.preventDefault();
        item.classList.toggle("open");
        e.target.parentNode.querySelector("ul").classList.toggle("open");
      });
    });
};

const addRegionalRedirectCookies = () => {
  String.prototype.splice = function(index, count, add) {
    if (index < 0) {
      index = this.length + index;
      if (index < 0) {
        index = 0;
      }
    }
    return this.slice(0, index) + (add || "") + this.slice(index + count);
  };

  const removeSlashBefore = str => {
    if (!str) {
      return "";
    }
    const trimmed = str.trim();
    return trimmed[0] !== "/" ? trimmed : trimmed.splice(0, 1);
  };

  const removeTrailingSlash = uri => {
    if (!uri) {
      return "";
    }
    return uri.trim()[uri.trim().length - 1] !== "/"
      ? uri
      : uri.splice(uri.lastIndexOf("/"), 1);
  };

  const redirectReference = {
    au: { language: "en-au", country: "au" },
    "ca-en": { language: "en-ca", country: "ca" },
    "ca-fr": { language: "fr-ca", country: "" },
    fi: { language: "fi", country: "fi" },
    gb: { language: "en-gb", country: "gb" },
    ko: { language: "ko", country: "kr" },
    "la-es": {
      language: "es",
      country: "",
    },
    zh: { language: "zh-hk", country: "hk" },
    sv: { language: "sv", country: "se" },
    it: { language: "it", country: "it" },
    fr: { language: "fr", country: "fr" },
    pl: { language: "pl", country: "pl" },
    jp: { language: "ja", country: "jp" },
    de: { language: "de", country: "de" },
    es: { language: "es-es", country: "es" },
    nl: { language: "nl", country: "nl" },
    gsw: { language: "de-ch", country: "" },
    za: { language: "en-za", country: "za" },
    ch: { language: "fr-ch", country: "" },
    nz: { language: "en-nz", country: "nz" },
    "ar-ae": { language: "ar", country: "ae" },
    en: { language: "en-us", country: "us" },
    sg: { language: "en", country: "sg" },
  };

  const setCookie = (name, value, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    if (typeof document !== "undefined") {
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
  };

  document
    .querySelectorAll('.nav__list[data-subnav="Choose region"] li > .nav__link')
    .forEach(item => {
      item.addEventListener("click", e => {
        console.log("Listener fired!", e.target.pathname);
        e.preventDefault();
        const uri = removeSlashBefore(removeTrailingSlash(e.target.pathname));
        const code = uri == "" ? "en" : uri;
        setCookie("nf_lang", redirectReference[code].language, 60);
        setCookie("nf_country", redirectReference[code].country, 60);
        window.location = e.target.pathname;
      });
    });
};

const init = () => {
  addActiveNavClass();
  addMobileTogglerHandlers();
  addMobileSubMenuHandlers();
  addNavScrollHandler();
  addFooterHandlers();
  addRegionalRedirectCookies();
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/headerfooter-vanilla.js